export default __webpack_public_path__ + "static/media/VRF-System.207ebff8.jpeg";